export default __webpack_public_path__ + "7c620aef600950879d91dec05ba02fc5.png";